/** Textes « caisseVehicule » — le français fait foi. */
export const caisseVehicule = {
  etatsJour: { loue: 'louée', reserve: 'réservée', entretien: 'au garage', libre: 'libre' },
  /** Jours de la semaine abrégés, dimanche d'abord (Date.getDay). */
  jours: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  erreurChargement: 'Cette voiture n\'a pas pu être chargée.',
  erreurTitre: 'Cette fiche ne s\'affiche pas',
  tarifs: (haute: string, basse: string) => ` été ${haute} / hiver ${basse} par jour`,
  toutesVoitures: '← Toutes les voitures',
  kpi: {
    genere: 'Généré ce mois',
    genereDetail: (j: number, n: number) => `${j} jour(s) loué(s) · ${n} location(s)`,
    encaisse: 'Encaissé ce mois',
    encaisseAvance: (m: string) => `dont ${m} d'avance`,
    encaisseDeja: (m: string) => `${m} déjà reçus un mois précédent`,
    encaisseDetail: 'l\'argent reçu ce mois-ci',
    resteDu: 'Reste dû',
    resteDuDetail: 'sur les locations du mois',
    toutEncaisse: 'tout est encaissé',
    cout: 'Ce qu\'elle a coûté',
    net: (m: string) => `net : ${m}`,
  },
  reserveApres: {
    titre: (j: number) => `Déjà réservée ${j} jour(s) après ce mois`,
    texte: ' sont déjà promis au-delà du mois affiché. Ce n\'est pas encore gagné, mais la voiture n\'est plus libre.',
  },
  moisVoiture: (mois: string) => `Le mois de la voiture — ${mois}`,
  legende: { louee: 'Louée', reservee: 'Réservée', entretien: 'Entretien', libre: 'Libre' },
  pied: {
    loues: (j: number) => `${j} j loué${j > 1 ? 's' : ''}`,
    reserves: (j: number) => ` · ${j} réservé(s)`,
    garage: (j: number) => ` · ${j} au garage`,
  },
  locationsMois: 'Les locations du mois',
  pasSortie: 'Cette voiture n\'est pas sortie ce mois-ci',
  colonnesLocations: {
    dossier: 'Dossier', client: 'Client', jours: 'Jours', total: 'Total', encaisse: 'Encaissé', solde: 'Solde',
  },
  aCredit: ' · à crédit',
  mouvements: (n: number) => `Chaque mouvement de caisse — ${n} ce mois-ci`,
  aucunMouvement: 'Aucun mouvement de caisse sur cette voiture',
  colonnesMouvements: {
    date: 'Date', type: 'Type', quoi: 'Ce qui s\'est passé', par: 'Par', recu: 'Reçu',
    enDevise: (devise: string) => `En ${devise}`,
  },
  dossier: (n: string) => `dossier ${n}`,
  avance: (du: string, au: string) => `Encaissé d'avance — location du ${du} au ${au}`,
  retard: (du: string, au: string) => `Payé après coup — location du ${du} au ${au}`,
  annulee: 'Location annulée depuis — l\'argent est resté',
  cout: (m: string) => `Ce que la voiture a coûté — ${m}`,
  aucuneDepense: 'Aucune dépense sur cette voiture ce mois-ci',
  colonnesDepenses: { date: 'Date', quoi: 'Quoi', detail: 'Détail', montant: 'Montant' },
  refacturee: ' · refacturée au client',
  note: '« Généré » est ce que la voiture a produit sur les jours de ce mois, au prorata : une location à cheval sur deux mois est partagée entre eux. « Encaissé » est l\'argent réellement reçu ce mois-ci pour cette voiture, quelle que soit la date de la location : une location d\'octobre payée en septembre est comptée dans la caisse de septembre, et les deux mois le rappellent. Les deux chiffres ne sont donc pas les mêmes, et c\'est normal. « Net » retire les entretiens et les amendes restées à votre charge.',
};
